module.exports = __webpack_public_path__ + "static/media/wine-white.2a0bf921.jpg";